import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { useZed } from '@modules/core/src/react/useZed';
import { StandardModule } from '@modules/standard/src/StandardModule';
import { zams } from '@zams/logger/zed/generated/loggerMap';
import { useEffect, useMemo, useState } from 'react';

import { CompassResponse } from '../ecs/component/response/Compass';
import { UnitResponse } from '../ecs/component/response/Unit';
import { getTourDanjiMetaData, TourDanjiModule } from '../TourDanjiModule';

import compassImage from './assets/compass.png';
import { useScreen } from './hooks/useScreen';

const width = 36;
const height = 36;

export function CompassPanel() {
  const zed = useZed<[BabylonjsModule, StandardModule, TourDanjiModule]>();
  const [compass, setCompass] = useState<CompassResponse | undefined>(undefined);
  const [selectedUnit, setSelectedUnit] = useState<UnitResponse | undefined>(undefined);
  const screenInfo = useScreen();
  const { isDesktop } = screenInfo;
  useEffect(() => {
    if (!zed) return;

    const onUpdateCompassUI = zed.api.observer.onUpdateCompassUI.add((data) => {
      setCompass(data);
    });
    const onUnitActivated = zed.api.observer.onUnitActivated.add((data) => {
      setSelectedUnit(data);
    });

    return () => {
      onUpdateCompassUI?.remove();
      onUnitActivated?.remove();
    };
  }, [zed]);

  const topOffset = isDesktop ? 213 : 176;
  const rightOffset = isDesktop ? 24 : 12;
  if (!compass)
    return null;


  return (
    <div style={{ position: 'absolute', width: width, height: height, top: topOffset, right: rightOffset }}>
        <img
        src={compassImage}
        alt="CompassImage"
        style={{
            width: '100%',
            height: '100%',
            pointerEvents: 'auto',
            position: 'absolute',
            rotate: `${compass.angle}deg`,
        }}
        onClick={async () => {
            if (!!selectedUnit) return;
            const direction = await zed?.api.changeNextViewDirection();
            const metaData = getTourDanjiMetaData();
            if (direction) {
            zams
                .z131()
                .setAllParams({
                screen_name: metaData.screen_name,
                ...(metaData.deal_type && { deal_type: metaData.deal_type }),
                ...(metaData.item_type && { item_type: metaData.item_type }),
                ...(metaData.ho_id && { ho_id: metaData.ho_id }),
                area_danji_id: metaData.danjiId,
                dong: metaData.dong,
                ho: metaData.ho,
                item_id: metaData.itemId,
                status_value: direction,
                })
                .send();
            }
        }}
        />
    </div>
  );
}
